
import { lookupCustomer } from '@/api';

import { Component, Prop, Vue } from 'vue-property-decorator';
import Icon from '@/components/UI/Icon.vue';
import { fetchJobUnlock, fetchSetJobCustomerCode, fetchSetJobLock } from '@/helpers/fetchers';
import { JobComplianceData } from '@/models/JobComplianceTypes';
import { mapState } from 'vuex';
import { User } from '@/models/main';
import { JobLockError, ValidationAPIError } from '@/helpers/throwables';
import { notifyNetworkError } from '@/helpers/notifiers';
import LookupCustomerCode from '@/components/UI/LookupCustomerCode.vue';

@Component({
  components: {
    Icon,
    LookupCustomerCode,
  },
  computed: {
    ...mapState('moduleUser', { user: 'user' }),
  },
})
export default class JobChangeCustomer extends Vue {
  @Prop({ type: Object, required: false, default: false }) public formData: JobComplianceData;

  public autocompleteCustomer = lookupCustomer;

  private user!: User;
  public loading = false;

  public customerCode = '';
  public onCustomerCodeChange(value: string) {
    this.customerCode = value;
  }

  public async setCustomerCode() {
    this.loading = true;

    await fetchSetJobLock(this.formData.rockhopper_id, this.formData.rockhopper_date)
      .then(async () => {
        await fetchSetJobCustomerCode(this.formData.rockhopper_id, this.formData.rockhopper_date, {
          customer_code: this.customerCode,
        })
          .then(() => {
            this.$emit('fetchData');
          })
          .catch(err => {
            if (err instanceof ValidationAPIError) {
              notifyNetworkError({ text: err.message });
            }
          })
          .finally(async () => {
            await fetchJobUnlock(this.formData.rockhopper_id, this.formData.rockhopper_date);
          });
      })
      .catch(err => {
        if (err instanceof JobLockError) {
          return;
        }
      });

    this.loading = false;
  }

  private async mounted() {
    this.customerCode = this.formData.customer;
  }
}
